<template>
    <v-app>
        <div class="AdminDashboard">
            <v-toolbar>
                <v-btn text @click="createDb">Create DB</v-btn>
                <v-btn text @click="deleteDb" class="ml-3">Delete Db</v-btn>
            </v-toolbar>

        </div>
    </v-app>
</template>

<script>
    import {ParseDbService} from '../../services';
    import {CommonService} from '../../services';

    export default {
        name: "AdminDashboard",
        methods: {
            createDb() {
                CommonService.showTextDialog("Creating table", true);
                ParseDbService.createDb((message, error) => {
                    if (message != null) {
                        this.$store.state.textMessage += "\n" + message
                    } else {
                        this.$store.state.textMessage += "\n Error: " + error
                    }
                }).then(() => {

                }).catch(ex => {
                    console.log(ex);
                }).finally(() => {
                    }
                )
            },
            deleteDb() {
                if (confirm('Are you sure you want to delete this item?')) {
                    CommonService.showTextDialog("Deleting all table", true);
                    ParseDbService.deleteAll((message, error) => {
                        if (message != null) {
                            this.$store.state.textMessage += ("\n" + message)
                        } else {
                            this.$store.state.textMessage += ("\nError:  " + error)
                        }
                    })
                }
            }
        }
    }
</script>